import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Group, Text, Box, Textarea } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { IconTrash } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { safeValue } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";

import SerahTerimaFotoDropper from "./SerahTerimaFotoDropper";

const SudahInputSerahTerima = ({
    stateData,
    fnRefreshIndex,
    fnCloseDrawer,
    fnSuccessSubmit,
    fnClickPhoto
}) => {

    const mountedRef = React.useRef(true);
    const { URI1 } = useParams();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const heightImage = 150;

    const notificationId = React.useRef({
        errorGetData: 'sudahInputSerahTerima-1',
        errorDeleteData: 'sudahInputSerahTerima-2',
        errorCatatanSerahTerima: 'sudahInputSerahTerima-3',
    })

    const canEditSerahTerima = React.useRef([
        utils.penjemputanSteps.nota.value,
        utils.penjemputanSteps.segera_menjemput.value,
        utils.penjemputanSteps.sedang_menjemput.value,
        utils.penjemputanSteps.sudah_input_data.value,
    ])

    const [data, setData] = React.useState({
        data: [],
        dataFlag: 'idle',
        dataInitLoading: false,

        trxId: '',

        catatanSerahTerimaModalValue: '',
        catatanSerahTerimaModal: false,
        catatanSerahTerimaSubmitLoading: false,
        catatanSerahTerima: '',

        dataPhoto: [],

        deleteModal: false,
        deleteId: '',
        deleteName: '',
        deleteLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    React.useEffect(() => {
        if (URI1) {

            setData(d => ({ ...d, dataInitLoading: true }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('flag_all', utils.flagAll);
            formDT.append('trx_id', URI1);
            formDT.append('current_step', stateData.utilsRef.currentStep);
            formDT.append('is_cancel', stateData.utilsRef.isCancel);

            axios({
                method: 'post',
                url: BE_API_THREE + '/data_init_delivery_penjemputan__by_penjemputan_id_serah_terima',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, dataInitLoading: false }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        data: response.data.data,
                        dataFlag: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? true : false,

                        dataPhoto: response.data.data_foto,

                        trxId: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['delivery_jemput_id'] : '',

                        catatanSerahTerima: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['catatan_serah_terima'] : '',
                    }))
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorGetData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    dataInitLoading: false
                }))

                notifications.show({
                    id: notificationId.current.errorGetData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }, [handleSetLoginContext, loginContext, loginContext.syswebapp, URI1, stateData.utilsRef.currentStep, stateData.utilsRef.isCancel])

    const deleteData = () => {
        setData(d => ({ ...d, deleteLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', data.trxId);
        formDT.append('current_step', stateData.utilsRef.currentStep);
        formDT.append('is_cancel', stateData.utilsRef.isCancel);
        formDT.append('foto_id', data.deleteId);
        formDT.append('foto_name', data.deleteName);

        axios({
            method: 'post',
            url: BE_API_THREE + '/delete_delivery_jemput_serah_terima',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false, deleteModal: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({ ...d, dataPhoto: response.data.data }));
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                deleteLoading: false,
                deleteModal: false
            }))

            notifications.show({
                id: notificationId.current.errorDeleteData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const handleCatatanSerahTerima = () => {
        setData(d => ({ ...d, catatanSerahTerimaSubmitLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', data.trxId);
        formDT.append('current_step', stateData.utilsRef.currentStep);
        formDT.append('is_cancel', stateData.utilsRef.isCancel);
        formDT.append('catatan', data.catatanSerahTerimaModalValue);

        axios({
            method: 'post',
            url: BE_API_THREE + '/update_delivery_jemput_catatan_serah_terima',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, catatanSerahTerimaSubmitLoading: false, catatanSerahTerimaModal: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({ ...d, catatanSerahTerima: data.catatanSerahTerimaModalValue }));
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorCatatanSerahTerima,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                catatanSerahTerimaSubmitLoading: false,
                catatanSerahTerimaModal: false
            }))

            notifications.show({
                id: notificationId.current.errorCatatanSerahTerima,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group spacing={6}>
                        <Text fw='normal'>Foto Serah Terima</Text>
                        <Text fw='normal'>({Array.isArray(data.dataPhoto) ? data.dataPhoto.length : 0})</Text>
                    </Group>
                }
                stateWithAsterisk={false}
                stateError=''
                stateDescription=''
            >
                {Array.isArray(data.dataPhoto) && data.dataPhoto.length > 0 &&
                    <Carousel
                        withIndicators={false}
                        withControls={Array.isArray(data.dataPhoto) && (data.dataPhoto.length > 1)}
                        height={heightImage}
                        slideSize="33.333333%"
                        slideGap="xs"
                        loop
                        align="start"
                        mt='md'
                    >
                        {Array.isArray(data.dataPhoto) && Object.keys(data.dataPhoto).map((keyFB, index) => {
                            return (
                                <Carousel.Slide key={keyFB}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: heightImage + 'px'
                                        }}
                                    >
                                        <img
                                            alt={`foto-serah-terima-${index}`}
                                            src={`${ROOT_BASE_URL}${data.dataPhoto[keyFB].delivery_jemput_foto_serah_terima_file_name}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}

                                            onClick={() => fnClickPhoto({
                                                images: data.dataPhoto,
                                                title: 'Foto Barang',
                                                index: keyFB,
                                                fieldName: 'delivery_jemput_foto_serah_terima_file_name',
                                            })}
                                        />

                                        {canEditSerahTerima.current.includes(stateData.utilsRef.currentStep) ?
                                            <Box
                                                px='.5rem'
                                                sx={(tema) => ({
                                                    height: '30px',
                                                    backgroundColor: tema.fn.rgba('#404040', 0.75),
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'pointer'
                                                })}

                                                onClick={() => setData(d => ({
                                                    ...d,
                                                    deleteId: data.dataPhoto[keyFB].delivery_jemput_foto_serah_terima_id,
                                                    deleteName: data.dataPhoto[keyFB].delivery_jemput_foto_serah_terima_file_name,
                                                    deleteModal: true
                                                }))}
                                            >
                                                <Text color="#fff">
                                                    {String(Number(keyFB) + 1)}
                                                </Text>

                                                <IconTrash
                                                    size={18}
                                                    color='#fff'
                                                />
                                            </Box>
                                            :
                                            <Box
                                                px='.5rem'
                                                sx={(tema) => ({
                                                    height: '30px',
                                                    backgroundColor: tema.fn.rgba('#404040', 0.75),
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                })}
                                            >
                                                <Text color="#fff">
                                                    {String(Number(keyFB) + 1)}
                                                </Text>
                                            </Box>
                                        }
                                    </Box>
                                </Carousel.Slide>
                            )
                        })}
                    </Carousel>
                }

                {canEditSerahTerima.current.includes(stateData.utilsRef.currentStep) &&
                    <SerahTerimaFotoDropper
                        stateData={{
                            trxId: data.trxId,
                            currentStep: stateData.utilsRef.currentStep,
                            isCancel: stateData.utilsRef.isCancel,
                            // userAccess: stateData.userAccess,
                        }}

                        fnOnAdded={(dataArray) => {
                            setData(d => ({ ...d, dataPhoto: dataArray }));
                        }}
                    />
                }

                <Textarea
                    value={safeValue(data.catatanSerahTerima, '')}
                    minRows={3}
                    maxRows={4}
                    readOnly
                    onClick={!canEditSerahTerima.current.includes(stateData.utilsRef.currentStep) ?
                        () => { }
                        :
                        () => setData(d => ({
                            ...d,
                            catatanSerahTerimaModalValue: d.catatanSerahTerima,
                            catatanSerahTerimaModal: true
                        }))}

                    mt='1.5rem'
                    label='Catatan Serah Terima'
                    placeholder='Catatan / Keterangan Serah Terima'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </InputWrapperCustom>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.deleteModal}
                fnHide={() => setData(d => ({ ...d, deleteModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Hapus'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.deleteLoading}
                fnButtonAction={deleteData}
            >
                <Text size='sm'>
                    Hapus foto ini ?
                </Text>
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.catatanSerahTerimaModal}
                fnHide={() => setData(d => ({ ...d, catatanSerahTerimaModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Catatan Serah Terima').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.catatanSerahTerimaSubmitLoading}
                fnButtonAction={handleCatatanSerahTerima}
            >
                <Textarea
                    value={safeValue(data.catatanSerahTerimaModalValue, '')}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) => setData(d => ({
                        ...d,
                        catatanSerahTerimaModalValue: e.target.value
                    }))}

                    label=''
                    placeholder='Catatan / Keterangan Serah Terima'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </ModalTakeAction>

        </React.Fragment>
    )
}

export default SudahInputSerahTerima;